export const TOO_MANY_FILES_ERROR = 'Too many files selected: Attach up to 10 files.';
export const INVALID_FILE_SIZE_ERROR = 'File size too large. Please upload a file that is less than 30Mb';
export const INVALID_FILE_NAME_LENGTH_ERROR = 'The file name length exceeds 100 character limit';
export const INVALID_FILE_TYPE_ERROR =
  'Invalid file format. Please upload a file in one of the following formats: JPG, PNG, PDF';
